import type {
  CustomLandingPage,
  LandingPageBody,
  LandingPageParams,
} from "@apptus/esales-api";
import elevateClient from "@server/elevate";

import { marketCode } from "@features/market/config/market-config";
import type { ElevateMarket } from "./utils";

import mapCustomAttributes from "./mapCustomAttributes";

export default async function getRawLandingPage(
  market: ElevateMarket,
  input: LandingPageParams,
  config?: LandingPageBody,
): Promise<CustomLandingPage | undefined> {
  const { presentCustom = [], ...props } = input;
  const code = marketCode(market).toLowerCase();
  return elevateClient(market).query.landingPage(
    {
      viewId: "production",
      notify:
        process.env.NEXT_PUBLIC_ENVIRONMENT === "prod" &&
        typeof window !== "undefined",
      limit: 60,
      skip: 0,
      presentCustom: mapCustomAttributes(presentCustom, market),
      presentPrices: [
        `NG_${code}_best`,
        `NG_${code}_RRP`,
        `NG_${code}_pricematch`,
        `NG_${code}_campaign`,
      ],
      priceId: `NG_${code}_best`,
      ...props,
    },
    {
      navigation: {
        include: true,
      },
      recommendationLists: [{ id: "recs", algorithm: "TOP_PRODUCTS" }],
      primaryList: {
        include: true,
      },
      ...config,
    },
  );
}
